import LoginForm from './LoginForm.container';

export default LoginForm;
